<template>
  <div class="table-box">
    <div v-if="!scorePage">
      <div class="search-box">
        <Select v-model="class_id"
                placeholder="请选择班级"
                style="width:140px;margin-right: 10px"
        >
          <Option value="">全部班级</Option>
          <Option :value="item.class_id" v-for="(item,idx) in trainclasses" :key="idx">{{item.class_name}}</Option>
        </Select>
        <Select v-model="major_id"
                style="width:140px;margin-right: 10px"
                placeholder="请选择专业"
        >
          <Option value=" ">全部专业</Option>
          <Option :value="item.id" v-for="item in direction_info" :key="item.id">{{item.name}}</Option>
        </Select>
        <Select v-model="is_correct"
                style="width:140px;margin-right: 10px"
                placeholder="请选择状态"
        >
          <Option :value="item.value" v-for="item in stateArr" :key="item.value">{{item.title}}</Option>
        </Select>
        <Button type="primary" @click="query">查询</Button>
      </div>
      <Table ref="selection" :columns="columns" :data="all_labwork.body" @on-select="tableSelect"
             @on-select-all="tableSelectAll"></Table>
      <div class="page-box" v-if="all_labwork.page">
        <Page show-sizer
              show-total
              :page-size="all_labwork.page.page_size"
              :current="all_labwork.page.current"
              :total="all_labwork.page.count"
              @on-change="currentPage"
              @on-page-size-change="pageSizeChange"
        />
      </div>
    </div>
    <div v-else>
      <score :labwork_id="labwork_id" :test_paper_id="test_paper_id"></score>
    </div>
  </div>
</template>

<script>
  import score from "./score";
  import {mapActions, mapState} from "vuex";
  import moment from "moment";

  export default {
    name: "exercisesPaper",
    data() {
      return {
        scorePage: false,
        class_id: '',
        major_id: '',
        is_correct: '',
        stateArr: [
          {
            value: '',
            title: '全部状态'
          },
          {
            value: '1',
            title: '未评分'
          },
          {
            value: '2',
            title: '已评分'
          }
        ],
        labwork_id: null,
        test_paper_id: null,
        columns: [
          // {
          //     type: 'selection',
          //     width: 60,
          //     align: 'center'
          // },
          {
            title: 'ID',
            key: 'id',
            width: 65,
            sortable: true
          },
          {
            title: '学生姓名',
            key: 'create_name',
            sortable: true
          },
          {
            title: '学生账号',
            key: 'create_account'
          },
          {
            title: '所属班级',
            key: 'create_class'
          },
          {
            title: '所属专业',
            key: 'major',
            render: (h, params) => {
              return h('div', [
                h('span', {}, params.row.major_names.join(',')),
              ]);
            }
          },

          {
            title: '试卷名称',
            key: 'test_paper_name'
          },
          {
            title: '提交时间',
            key: 'time',
            sortable: true,
            render: (h, params) => {
              return h('div', [
                h('span', {}, moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss')),
              ]);
            }
          },
            {
                title: '状态',
                key: 'flow_state',
                sortable: true,
                width: 80,
                render: (h, params) => {
                    return h('div', [
                        h('span', {}, params.row.flow_state == 1 || params.row.flow_state==2 ? '未评分':'已评分'),
                    ]);
                }
            },
          {
            title: '评分',
            key: 'score',
            sortable: true,
            width: 80,
          },
          {
            title: '操作',
            key: 'action',
            width: 120,
            render: (h, params) => {
              return h('div', [
                h('a', {
                  style: {
                    marginRight: '5px',
                    color: '#029ff6'
                  },
                  on: {
                    click: () => {
                      this.goScorePage(params.row)
                    }
                  }
                }, '去评分'),
                // h('a', {
                //   style: {
                //     marginRight: '5px',
                //     color: '#029ff6'
                //   },
                //   on: {
                //     click: () => {
                //       this.deleteRow(params)
                //     }
                //   }
                // }, '删除'),
              ]);
            }
          },
        ],
        page_num: 1,
        page_size: 20,
      }
    },
    components: {
      score
    },
    computed: {
      ...mapState({
        all_labwork: state => state.teachingScore.all_labwork,
        user_info: state => state.loginState.user_info,
        trainclasses: state => state.classAndStu.trainclasses,
        direction_info: state => state.courseManage.direction_info,
      }),
    },
    methods: {
      ...mapActions({
        getLabWork: 'teachingScore/get_labwork',
        getQbCenterDetails: 'teachingScore/getQbCenterDetails',
        getTrainclasses: 'classAndStu/getTrainclasses',
        getDirection: 'courseManage/getDirection',

      }),
      tableSelect(row) {

      },
      tableSelectAll(row) {

      },
      deleteRow(row){

      },
      query() {
        this.initLabWork()
      },
      goScorePage(row) {
        this.labwork_id = row.id
        this.test_paper_id = row.test_paper_id
        this.getQbCenterDetails({
          id: row.test_paper_id,
          callback: res => {
            this.scorePage = true
          }
        })

      },
      currentPage(num) {
        this.page_num = num
        this.initLabWork()
      },
      pageSizeChange(size) {
        this.page_size = size
        this.initLabWork()
      },
      initLabWork() {
        let _this = this
        this.getLabWork({
          page_num: _this.page_num,
          page_size: _this.page_size,
          major_id: _this.major_id,
          class_id: _this.class_id,
          is_correct: _this.is_correct
        })
      }
    },
    mounted() {
      this.initLabWork()
      this.getDirection()
      let collegeIds = this.user_info.collegeIds
      this.getTrainclasses(collegeIds.join(','))
    },
    watch: {
      'scorePage': function (val) {
        if (!val) {
          this.initLabWork()
        }

      },
    },
  }
</script>

<style scoped lang="less">
  @import "../../style/index";
</style>
